module.exports = __webpack_public_path__ + "static/media/gift-success.5d3f549b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gift-success.png
// module id = 1910
// module chunks = 6